// const { component, hook, thunk } = require('../odo/odojs/')

// const shouldkeepexistingfocus = () =>
//   document.activeElement != null
//     && document.activeElement.nodeName != null
//     && (document.activeElement.nodeName === 'SELECT'
//       || document.activeElement.nodeName === 'INPUT'
//       || document.activeElement.nodeName === 'TEXTAREA')

// const focushook = hook({
//   enter: (item, state, params, hub) => {
//     item.mount()
//     if (shouldkeepexistingfocus()) return
//     item.target().focus()
//   },
//   transition: (item1, item2, state, params, hub) => {
//     item2.mount()
//     if (shouldkeepexistingfocus()) return
//     item2.target().focus()
//   },
//   exit: (item, state, params, hub) => {
//     if (item == null) return
//     return item.unmount()
//   }
// })

// module.exports = (result) =>
//   thunk((previous) => {
//     if (previous != null && previous.vnode != null)
//       return previous.vnode
//     return focushook(component({
//       render: (state, params, hub) => result
//     }))
//   })()

// not currently working - default to normal
module.exports = result => result
